// react documenation used: https://react.dev/learn
// axios documentation used: https://axios-http.com/docs/intro
import React, { useState, useEffect } from "react";
import axios from "axios";
import styles from "./recentbar.module.css";

function RecentlyAccessed() {
  const [recentRepos, setRecentRepos] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchRecentlyAccessedRepos = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}/api/requests/grabRecentlyAccessed`
        );
        setRecentRepos(response.data);
      } catch (error) {
        console.error("Error fetching recently accessed repositories:", error);
      }
    };

    fetchRecentlyAccessedRepos();
  });

  //when a repo has been opened this function is called the repository is updated in the database when it was last accessed
  const handleUpdateLastAccessed = async (repo, event) => {
    event.preventDefault();

    try {
      await axios.post(
        `${apiUrl}/api/requests/recentlyAccessed/${repo.repository_id}`
      );
      window.open(repo.repository_url, "_blank", "noopener,noreferrer");
    } catch (error) {
      console.error("Error updating last accessed time:", error);
      window.open(repo.repository_url, "_blank", "noopener,noreferrer");
    }
  };

  // depending on whether the url provided in the repository details the icon changes, icons are from the public folder
  const getPlatformIcon = (url) => {
    if (url.includes("github.com")) {
      return "/github.png";
    } else if (url.includes("gitlab.com")) {
      return "/gitlab.png";
    } else {
      return null;
    }
  };

  return (
    <aside className={styles.recentlyAccessed}>
      <h3>Recently Trending Repositories</h3>
      <div>
        {recentRepos.map((repo, index) => (
          <div
            key={index}
            className={styles.repoBar}
            onClick={(e) => handleUpdateLastAccessed(repo, e)}
          >
            <img
              src={getPlatformIcon(repo.repository_url)}
              alt="Platform Icon"
              style={{ width: "20px", marginRight: "10px" }}
            />
            {repo.repository_name}
          </div>
        ))}
      </div>
    </aside>
  );
}

export default RecentlyAccessed;
